<template>
<div class="chapter">
<div class="inner_page">
<div class="block">
<p class="nonindent"><a id="page8"></a>‘She possessed, in the highest degree, all the qualities which were required in a great Prince.’</p>
<p class="right">G<span class="small">IOVANNI</span> S<span class="small">CARAMELLI</span>, Venetian Ambassador to the Court of Elizabeth Tudor, Queen of England</p>
</div>
<div class="block">
<p class="nonindent">‘I would have you know that this kingdom of mine is not so scant of men but there be a rogue or two among them.’</p>
<p class="right">E<span class="small">LIZABETH</span> T<span class="small">UDOR</span>, Queen of England</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795338557_epub_epi_r1.vue?9e15171c